<template>
  <section class="store-order-detail px-3 px-md-4 px-xl-5 pb-5 pt-md-4 pt-xl-4">
    <div class="d-flex justify-content-between align-items-center pt-xl-3">
      <h4 class="font-weight-bold text-left">購物紀錄</h4>
      <router-link class="btn btn-outline-success" :to="{ path: '/member/order/list', query: { source: 'store' } }">返回購物紀錄</router-link>
    </div>
    <OrderDetailSkeleton v-if="loading" />
    <div v-else-if="error" role="alert" class="text-center py-5">
      <p class="text-danger">{{ error }}</p>
      <button type="button" class="btn btn-outline-success" @click="load">重新載入</button>
    </div>
    <template v-else-if="order">
      <div class="d-flex pt-3 pb-2"><span>營業所訂單編號：</span><strong class="text-success">{{ order.order_number }}</strong></div>
      <div class="py-2">
        <div class="border">
          <div class="border-bottom text-center py-2">商品訂購資訊</div>
          <div class="row py-3">
            <div class="col-lg-6">
              <div class="d-flex"><div class="col-auto information-title py-2"><span v-for="(character, index) in '託運日期：'" :key="index">{{ character }}</span></div><div class="col py-2 summary-value">{{ order.consignment_date ? formatTime(order.consignment_date) : '尚未提供' }}</div></div>
              <div class="d-flex"><div class="col-auto information-title py-2"><span v-for="(character, index) in '查貨號碼：'" :key="index">{{ character }}</span></div><div class="col py-2 summary-value">{{ lookupNumbers }}</div></div>
              <div class="d-flex"><div class="col-auto information-title py-2"><span v-for="(character, index) in '收件人：'" :key="index">{{ character }}</span></div><div class="col py-2 summary-value">{{ delivery.receiver || '尚未提供' }}</div></div>
              <div class="d-flex"><div class="col-auto information-title py-2"><span v-for="(character, index) in '送貨地點：'" :key="index">{{ character }}</span></div><div class="col py-2 summary-value">{{ delivery.address || '尚未提供' }}</div></div>
              <div class="d-flex"><div class="col-auto information-title py-2"><span v-for="(character, index) in '訂單來源：'" :key="index">{{ character }}</span></div><div class="col py-2 summary-value">營業所郵寄訂單</div></div>
            </div>
            <div class="col-lg-6">
              <div class="d-flex"><div class="col-auto information-title py-2"><span v-for="(character, index) in '連絡手機：'" :key="index">{{ character }}</span></div><div class="col py-2 summary-value">{{ memberMobile }}</div></div>
              <div class="d-flex"><div class="col-auto information-title py-2"><span v-for="(character, index) in '備註：'" :key="index">{{ character }}</span></div><div class="col py-2 summary-value">{{ delivery.note || '尚未提供' }}</div></div>
              <div class="d-flex"><div class="col-auto information-title py-2"><span v-for="(character, index) in '發票號碼：'" :key="index">{{ character }}</span></div><div class="col py-2 summary-value">{{ order.invoice_number || '尚未提供' }}</div></div>
            </div>
          </div>
        </div>
      </div>
      <ShippingTrackingTimeline :shipments="order.shipments || []" :automatic-sync="true" />
      <div v-if="order.items.some(item => item.quantity === null)" class="alert alert-info">部分商品數量尚未提供，補齊數量後即可計算完整合計。</div>
      <div class="border products-table">
        <div class="product-row product-heading text-center">
          <div>商品</div><div></div><div>單價</div><div>積分</div><div>數量</div><div>金額小計</div><div>積分小計</div>
        </div>
        <div v-for="item in order.items" :key="item.product_number" class="product-row product-item border-top">
          <div class="product-photo p-3"><img v-if="item.image" :src="item.image" :alt="item.name || item.product_number"><span v-else class="text-muted">尚無商品圖片</span></div>
          <div class="product-name py-2"><div>{{ item.product_number }}</div><div>{{ item.name || '商品尚未對應' }}</div></div>
          <div class="product-value" data-label="單價">{{ money(item.unit_price) }}</div>
          <div class="product-value" data-label="積分">{{ value(item.unit_pv) }}</div>
          <div class="product-value" data-label="數量">{{ value(item.quantity) }}</div>
          <div class="product-value" data-label="金額小計">{{ money(item.subtotal) }}</div>
          <div class="product-value" data-label="積分小計">{{ value(item.subtotal_pv) }}</div>
        </div>
        <div class="border-top px-3 py-2">
          <div class="order-totals ml-auto">
            <div class="d-flex py-2 justify-content-between"><span class="totle-count-title"><span v-for="(character, index) in '訂單金額總計'" :key="index">{{ character }}</span></span><strong class="text-danger">{{ money(order.total_price) }}</strong></div>
            <div class="d-flex py-2 justify-content-between"><span class="totle-count-title"><span v-for="(character, index) in '訂單積分總計'" :key="index">{{ character }}</span></span><strong class="text-primary">{{ value(order.total_pv) }}</strong></div>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import { getStoreMailOrder } from '@/api/orders'
import ShippingTrackingTimeline from '@/components/order/ShippingTrackingTimeline.vue'
import dayjs from 'dayjs'
import OrderDetailSkeleton from '@/components/order/OrderDetailSkeleton.vue'
export default {
  components: { ShippingTrackingTimeline, OrderDetailSkeleton },
  data: () => ({ order: null, loading: false, error: '', requestId: 0 }),
  computed: {
    delivery() { return (this.order && this.order.delivery_details) || {} },
    lookupNumbers() { return [...new Set((this.order.shipments || []).map(s => s.lookup_number).filter(Boolean))].join('、') || '尚未提供' },
    memberMobile() { return this.$store.state.model.UserData.mobile_phone01 || '尚未提供' }
  },
  created() { this.load() },
  watch: { '$route.params.id'() { this.load() } },
  beforeDestroy() { this.requestId++ },
  methods: {
    value(v) { return v === null || v === undefined ? '尚未提供' : Number(v).toLocaleString('zh-TW') },
    money(v) { return v === null || v === undefined ? '尚未提供' : 'NT$ ' + this.value(v) },
    formatTime(v) { return dayjs(v).format('YYYY/MM/DD') },
    async load() {
      const id = ++this.requestId
      this.order = null; this.loading = true; this.error = ''
      try { const res = await getStoreMailOrder(this.$route.params.id); if (id === this.requestId) this.order = res.data } catch (e) {
        if (id === this.requestId) this.error = '無法查看此訂單，請確認登入狀態及貨態查詢權限。'
      } finally { if (id === this.requestId) this.loading = false }
    }
  }
}
</script>
<style scoped>
.summary-value { min-width: 0; overflow-wrap: anywhere; }
.product-row { display: grid; grid-template-columns: 132px 2fr repeat(6, 1fr); align-items: center; }
.product-heading { padding: 12px 0; }
.product-photo img { width: 100%; aspect-ratio: 1; object-fit: contain; }
.product-value { text-align: center; padding: 8px; }
.order-totals { max-width: 250px; }
@media (max-width: 991.98px) {
  .product-heading { display: none; }
  .product-item { grid-template-columns: 132px minmax(0, 1fr); }
  .product-name { padding-right: 12px; }
  .product-value { grid-column: 1 / -1; display: grid; grid-template-columns: 1fr 1fr; text-align: left; padding: 8px 16px; }
  .product-value::before { content: attr(data-label); }
}
</style>
